define('pages/englishlive2016/scrollTo',['$'], function($){
    'use strict';

    var $body = $('html,body');

    return function($target, offsetY){
        offsetY = offsetY>>0;
        var sumOfNavHeight = 0;
        var top;
        var overflow = $target[0].style.overflow;
        $target.css('overflow', 'hidden');
        top = $target.offset().top;

        $('nav').each(function(i, el){
            var $el = $(el);
            var position = $el.css('position');
            $el.css('position', 'static');
            if ($el.offset().top <= $target.offset().top) {
                sumOfNavHeight += $el.outerHeight(true);
            }
            $el.css('position', position);
        });
        
        top -= sumOfNavHeight;
        top += offsetY;
        $target.css('overflow', overflow);

        $body.animate({
            scrollTop: top
        });
    };
});
